<template>
<Expose class="tools" :ratio="0.2" @expose="$emit('expose')">
    <div class="tools-content">
        <div class="tools-content-left">
            <template v-for="item in leftItems">
                <a
                    :href="item.url"
                    :key="item.url"
                    target="_blank"
                    draggable="false"
                    @click="$emit('click', item)">
                    <div class="left-item">
                        <img class="img" :src="item.img" >
                        <div class="text">
                            <h3 class="title">{{item.title}}</h3>
                            <p class="desc">{{item.desc}}</p>
                        </div>
                    </div>
                </a>
            </template>
        </div>
        <div class="tools-content-right">
            <template v-for="item in rightItems">
                <a
                    :href="item.url"
                    target="_blank"
                    :key="item.url"
                    draggable="false"
                    @click="$emit('click', item)">
                    <div class="right-item" >
                        <img  class="img" :src="item.img" alt="">
                        <p class="text">{{item.title}}</p>
                    </div>
                </a>
            </template>
        </div>
    </div>
    <p class="tools-footer">
        <span>想了解更多设计能力，设计工具</span>
        <a href="https://koutu.gaoding.com/tools" target="_blank">
            <span>立即前往</span>
            <Icon type="right"/>
        </a>
    </p>
</Expose>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Icon } from '@gaoding/gd-antd';
import { LEFT_ITEMS, RIGHT_ITEMS } from './config';
import Expose from '../../../expose';
export default {
  name: 'tools',
  components: {
    Expose,
    Icon
  },
  computed: {
    leftItems() {
      return LEFT_ITEMS;
    },

    rightItems() {
      return RIGHT_ITEMS;
    }

  }
};
</script>
<style scoped>
h2,
h3,
p {
  margin: 0;
  padding: 0;
}
img {
  user-select: none;
}
.tools {
  width: 600px;
  height: 301px;
  padding: 8px;
  box-sizing: border-box;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  background: #3E3E3F;
  box-shadow: 0px 12px 16px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
}
.tools-content {
  display: flex;
  height: 232px;
}
.tools-content a {
  text-decoration: none;
}
.tools-content-left {
  width: 280px;
}
.tools-content-left .left-item {
  width: 280px;
  height: 112px;
  box-sizing: border-box;
  padding: 30px 23px;
  background: #484849;
  border-radius: 2px;
  text-align: left;
  margin-bottom: 8px;
}
.tools-content-left .left-item:hover {
  background: #5B5B5C;
  box-shadow: 0px 10px 32px rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  transition: box-shadow 0.2s, background-color 0.2s;
}
.tools-content-left .left-item .img {
  width: 52px;
  height: 52px;
  float: left;
}
.tools-content-left .left-item .text {
  display: flow-root;
  margin-top: 5px;
  margin-left: 64px;
}
.tools-content-left .left-item .text .title {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.9);
}
.tools-content-left .left-item .text .desc {
  margin-top: 4px;
  font-size: 13px;
  line-height: 20px;
  color: #fff;
  opacity: 0.4;
}
.tools-content-right {
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: space-between;
}
.tools-content-right .right-item {
  margin-left: 8px;
  width: 144px;
  height: 52px;
  box-sizing: border-box;
  padding: 15px 14px;
  background: #484849;
  border-radius: 2px;
  color: rgba(255, 255, 255, 0.9);
}
.tools-content-right .right-item:hover {
  background: #5B5B5C;
  box-shadow: 0px 10px 32px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s, background-color 0.2s;
}
.tools-content-right .right-item .img {
  width: 24px;
  height: 24px;
  float: left;
}
.tools-content-right .right-item .text {
  margin-left: 28px;
  text-align: left;
  margin-top: 1px;
  font-weight: 700;
  font-size: 13px;
  line-height: 20px;
}
.tools-footer {
  margin: 0 16px 0 0;
  font-size: 14px;
  line-height: 14px;
  text-align: right;
  margin-top: 24px;
  color: rgba(255, 255, 255, 0.4);
}
.tools-footer .g-icon {
  margin-top: -1px;
}
.tools-footer span {
  vertical-align: top;
}
.tools-footer a {
  margin-left: 8px;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
}
.tools-footer a:hover {
  color: #fff;
}

</style>
